import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Components
import PortsDropdown from '../../dropdowns/PortsDropdown';
import { Checkbox } from '@gulfwinds/ui-components';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';
import { getPorts as fetchData } from 'src/fetch/ports';
import { getPorts, setPorts } from 'src/slices/ports';
// Helpers
import { has } from 'lodash';

const PortsFilter = ({
  filter, onFilterChange, fieldsNameForSearch, fieldInfo,
}) => {
  const { value } = filter;
  const dispatch = useDispatch();
  const ports = useSelector(getPorts);
  const [displayValue, setDisplayValue] = useState(!filter.compareWithOtherField ? value : null);
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value.id,
      fieldInfo,
    };
    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    const setValue = filter.compareWithOtherField ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(value);
  }, [value]);

  useEffect(() => {
    if (!has(filter, 'fieldInfo')) {
      onFilterChange.call(undefined, {
        nextFilter: {
          ...filter,
          fieldInfo,
        },
      });
    }
  }, []);

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value ? {
      ...filter,
      value: typeof compareWithOtherFieldDisplayValue === 'object'
        ? compareWithOtherFieldDisplayValue?.field : compareWithOtherFieldDisplayValue,
      compareWithOtherField: true,
      fieldInfo,
    } : {
      field: filter.field,
      operator: filter.operator,
      value: typeof displayValue === 'object' ? displayValue?.value : displayValue,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    const setValue = !value ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(null);
    setCompareWithOtherField(value);
  };

  useEffect(() => {
    if (!ports || ports.length === 0) {
      fetchData().then((data) => dispatch(setPorts({ ports: data })));
    }
  }, []);

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0
        ? (
          <FieldsToSelectDropdown
            fields={fieldsNameForSearch}
            onFieldChanged={handleFieldToCompareChanged}
            value={compareWithOtherFieldDisplayValue}
          />
        ) : (
          filter.operator !== 'isnull' && filter.operator !== 'isnotnull'
        ) && <PortsDropdown onChange={onChange} value={displayValue} clearButton={false} />}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default PortsFilter;
